import React, { useState } from 'react';
import { Field } from 'formik';
import { InputAdornment } from '@material-ui/core';
import { TextField } from 'formik-material-ui';

import AnimateListItem from './animations/AnimateListItem';
import Password from 'public/icons/form/password.svg';
import PasswordEyeIcon from 'public/icons/eye-purple.svg';
import SlashEyeIcon from 'public/icons/eye-hide-purple.svg';

const mainColor = { fill: '#5b00db' };

const PasswordConfirmation = () => {
  const [showPassword, setShowPassword] = useState({ password: false, confirmation: false });

  const handleClickShowPassword = () =>
    setShowPassword(prevState => ({ ...prevState, password: !prevState.password }));
  const handleClickShowPasswordConfirmation = () =>
    setShowPassword(prevState => ({ ...prevState, confirmation: !prevState.confirmation }));

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <>
      <AnimateListItem>
        <Field
          component={TextField}
          name="password"
          type={showPassword.password ? 'text' : 'password'}
          placeholder="Password"
          variant="outlined"
          color="primary"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Password width={14} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <div
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  style={{ height: 20, cursor: 'pointer' }}
                >
                  {showPassword.password ? (
                    <PasswordEyeIcon width={20} height={20} />
                  ) : (
                    <SlashEyeIcon style={mainColor} width={20} height={20} />
                  )}
                </div>
              </InputAdornment>
            ),
          }}
        />
      </AnimateListItem>

      <AnimateListItem>
        <Field
          component={TextField}
          name="password_confirmation"
          type={showPassword.confirmation ? 'text' : 'password'}
          placeholder="Repeat Password"
          variant="outlined"
          color="primary"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Password width={14} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <div
                  onClick={handleClickShowPasswordConfirmation}
                  onMouseDown={handleMouseDownPassword}
                  style={{ height: 20, cursor: 'pointer' }}
                >
                  {showPassword.confirmation ? (
                    <PasswordEyeIcon style={mainColor} width={20} height={20} />
                  ) : (
                    <SlashEyeIcon style={mainColor} width={20} height={20} />
                  )}
                </div>
              </InputAdornment>
            ),
          }}
        />
      </AnimateListItem>
    </>
  );
};

export default PasswordConfirmation;
